import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { FavoriteIconUrlViewModel } from 'autogen/swagger/all';
import { _LoginInfo, type _LoginInfoParams } from 'autogen/swagger/all';
import { Favorites } from 'autogen/translation-keys/trans-website-shared';
import Icon from 'components/Icon';
import useLoginInfoQuickView from 'components/login/shared/hooks/useLoginInfoQuickView';
import { SessionMenuAnchorItem, SessionMenuItem } from 'components/SessionMenu/components/SessionMenuItem';
import dynamic from 'helpers/dynamic';
import useIsAuthenticated from 'hooks/user/useIsAuthenticated';
import { breakpoint, sizes } from 'variables';
import { HeaderItemText } from './shared/styles';

const FavoriteQuantityBadge = dynamic(() => import('components/generic/badge/badges/FavoriteQuantityBadge'), {
    ssr: false
});

const StyledFavoriteQuantityBadge = styled(FavoriteQuantityBadge)`
    position: absolute;
    top: -6px;
    right: -2px;

    ${breakpoint.up(sizes.lg)} {
        right: 4px;
    }
`;

export default function Favorite({
    model: { loginRequest, myFavoritesLinkAction }
}: {
    model: FavoriteIconUrlViewModel;
}) {
    const isAuthenticated = useIsAuthenticated();
    const [, toggle] = useLoginInfoQuickView();
    const { t } = useTranslation();

    const loginParams: _LoginInfoParams = {
        productId: null,
        infoType: loginRequest.infoType,
        level: 'Soft',
        mode: loginRequest.mode,
        returnUrl: loginRequest.returnUrl
    };

    if (!isAuthenticated) {
        return (
            <>
                <SessionMenuItem
                    icon={<Icon type="Heart" size={16} aria-hidden />}
                    onClick={() => {
                        toggle({ isOpen: true }); // open login modal immediately with no data
                        _LoginInfo(loginParams).then((loginInfo) => toggle({ isOpen: true, loginInfo })); // update login modal with fetched login data
                    }}
                >
                    <HeaderItemText>{t(Favorites)}</HeaderItemText>
                </SessionMenuItem>
            </>
        );
    }

    return (
        <SessionMenuAnchorItem
            icon={<Icon type="Heart" size={16} aria-hidden />}
            aria-label={t(Favorites)}
            action={myFavoritesLinkAction}
        >
            <StyledFavoriteQuantityBadge />
            <HeaderItemText>{t(Favorites)}</HeaderItemText>
        </SessionMenuAnchorItem>
    );
}
